import { render, staticRenderFns } from "./MayinTarlasi.vue?vue&type=template&id=092467a8&scoped=true&"
import script from "./MayinTarlasi.vue?vue&type=script&lang=js&"
export * from "./MayinTarlasi.vue?vue&type=script&lang=js&"
import style0 from "./MayinTarlasi.vue?vue&type=style&index=0&id=092467a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092467a8",
  null
  
)

export default component.exports